'use client';

import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useCartStore } from 'components/shared/Cart';
import { useTranslations } from 'next-intl';
import styles from './HsaFsaComponent.module.css';

export const FSAHSAComponent = ({ className }: { className?: string }) => {
  const t = useTranslations('common');
  const store = useCartStore((s) => s.store);

  if (store !== ShopifyStore.US) return null;
  return (
    <div className={[styles.root, className, 'fsa-hsa'].filter(Boolean).join(' ')}>
      <CheckIcon />
      <span>
        <b>{t('hsaFsaComponent.content.hsaFsa')}</b>{' '}
        {t('hsaFsaComponent.text.eligible')}
      </span>
    </div>
  );
};

export const FSAHSAComponentIP = ({
  className,
  colorScheme = 'light',
}: {
  className?: string;
  colorScheme?: string;
}) => {
  const t = useTranslations('common');
  const { region: country } = useRegionLocale();

  if (country !== 'US' && country !== 'PR') return null;
  return (
    <div
      className={[styles.rootIp, className, colorScheme, 'fsa-hsa']
        .filter(Boolean)
        .join(' ')}
    >
      <CheckIcon fill={colorScheme === 'dark' ? 'white' : 'black'} />
      <span>
        <b>{t('hsaFsaComponent.content.hsaFsa')}</b>{' '}
        {t('hsaFsaComponent.text.eligible')}
      </span>
    </div>
  );
};

const CheckIcon = ({
  className,
  style,
  fill = 'black',
}: {
  className?: string;
  style?: React.CSSProperties;
  fill?: string;
}) => {
  return (
    <svg
      className={className}
      style={style}
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0445803 12.2808C0.655407 6.11158 6.63525 1.48262 12.762 2.25157C13.9411 2.39926 15.072 2.80381 16.1773 3.21076L15.4581 4.53916C15.292 4.65635 15.0568 4.43562 14.893 4.37382C9.48871 2.35191 3.44627 5.35306 1.91157 10.8979C-0.140032 18.3072 6.69464 25.0906 14.0928 22.9988C20.1409 21.2891 22.9991 14.3092 19.9659 8.77482C19.8366 8.53803 19.1544 7.61657 19.1431 7.505C19.1143 7.21043 19.7564 6.40295 19.9105 6.10195C22.6123 9.05575 23.4205 13.3925 22.1596 17.1795C20.4972 22.1721 15.4413 25.4108 10.2023 24.8795C5.01949 24.3537 0.504506 19.98 0.0445803 14.7691C-0.0116061 14.1326 -0.0180274 12.9117 0.0445803 12.2808Z"
        fill={fill ?? 'black'}
      />
      <path
        d="M21.0742 0.723199L11.081 18.1402L6.15346 12.8362L6.15186 12.65L7.22823 11.6402L10.8402 15.5717L19.7096 0L21.0742 0.723199Z"
        fill={fill ?? 'black'}
      />
    </svg>
  );
};
